import { partCreatorConstants } from "../constants/partCreator.constants";
export function partCreator(
  state = [{ searchBy: "Part Number" }],
  action,
) {
  if (action && action.type) {
    switch (action.type) {
      // Quotes
      case partCreatorConstants.PART_CREATOR_REQUEST:
        return { retrievingPBH: true };

      case partCreatorConstants.PART_CREATOR_SUCCESS:
        return { orders: action.orders };

      case partCreatorConstants.PART_CREATOR_FAILURE:
        return {};

      // Quotes Search Query
      case partCreatorConstants.PART_CREATOR_SEARCH_REQUEST:
        return { searchingPBH: true };
      case partCreatorConstants.PART_CREATOR_SEARCH_SUCCESS:
        return { orders: action.orders };
      case partCreatorConstants.PART_CREATOR_SEARCH_FAILURE:
        return {};

      default:
        return state;
    }
  }
}
